module.exports = __webpack_public_path__ + "img/1437928702.414abd19.jpg";